/*
 * @Description  :
 * @Author       : git config user.sname
 * @Date         : 2025-12-17 09:57:13
 * @LastEditors  : 王帅
 * @LastEditTime : 2026-02-03 09:02:55
 * @FilePath     : \ngs_platform_manage_admin\src\api\modules\commodity-management.js
 */
import request from "../request.js";

// 商品列表-商品分类级联查询    ====孙强
export const getGoodCatCascade = function (data) {
    return request({
        url: `/bmPayment/getGoodCatCascade`,
        method: 'post',
        data
    })
}
//商品列表-收费字段级联查询   ====孙强
export const getFeeFieldCascade = function (data) {
    return request({
        url: `/bmPayment/getFeeFieldCascade`,
        method: 'post',
        data
    })
}
//商品列表分页  ====孙强
export const getGoodPage = function (data) {
    return request({
        url: `/bmPayment/getGoodPage`,
        method: 'post',
        data
    })
}
//商品列表-新增编辑   ====孙强
export const insertOrUpdateGood = function (data) {
    return request({
        url: `/bmPayment/insertOrUpdateGood`,
        method: 'post',
        data
    })
}

//商品列表-详情   ====孙强
export const getGoodDetail = function (data) {
    return request({
        url: `/bmPayment/getGoodDetail`,
        method: 'post',
        data
    })
}
//商品列表-删除   ====孙强
export const delGood = function (data) {
    return request({
        url: `/bmPayment/delGood`,
        method: 'post',
        data
    })
}

//商品文件保存  ====孙强
export const saveFile = function (data) {
    return request({
        url: '/bmPayment/saveFile',
        method: 'post',
        headers: {
            token: sessionStorage.getItem('ngs_platform_token')
        },
        requestConfig: {
            hideLoading: true
        },
        data
    })
}
//商品文件删除  ====孙强
export const deleteFile = function (data) {
    return request({
        url: '/bmPayment/deleteFile',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}


export const getGiveGoodList = function (data) {
    return request({
        url: `/bmPayment/getGiveGoodList`,
        method: 'post',
        data
    })
}
